// extracted by mini-css-extract-plugin
export var sectionAbout = "about-section-module--section-about--3h5MT";
export var aboutContent = "about-section-module--about-content--1syJk";